<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row">
                <div class="col-xl-4 col-lg-6">
                    <stats-card title="WINDOWS" type="gradient-blue" :sub-title="latest_Windows" icon="fab fa-windows"
                        class="mb-4 mb-xl-0">
                        <template slot="footer">
                            <span class="mr-2"> <a-tag color="blue"> {{ latest_Windows_Status }} </a-tag> </span>
                            <br>
                            <span class="mr-2"> <a-tag color="blue"> {{ latest_Windows_At }} </a-tag> </span>
                            <br>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-4 col-lg-6">
                    <stats-card title="LINUX" type="gradient-red" :sub-title="latest_Linux" icon="fab fa-linux"
                        class="mb-4 mb-xl-0">
                        <template slot="footer">
                            <span class="mr-2"> <a-tag color="red"> {{ latest_Linux_Status }} </a-tag> </span>
                            <br>
                            <span class="mr-2"> <a-tag color="red"> {{ latest_Linux_At }} </a-tag> </span>
                            <br>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-4 col-lg-6">
                    <stats-card title="MAC" type="gradient-gray" :sub-title="latest_Mac" icon="fab fa-apple"
                        class="mb-4 mb-xl-0">
                        <template slot="footer">
                            <span class="mr-2"> <a-tag color="gray"> {{ latest_Mac_Status }} </a-tag> </span>
                            <br>
                            <span class="mr-2"> <a-tag color="gray"> {{ latest_Mac_At }} </a-tag> </span>
                            <br>
                        </template>
                    </stats-card>
                </div>
            </div>
        </base-header>
        <a-drawer v-if="drawerVisible" title="" :width="480" placement="right" @close="onClose" :visible="drawerVisible"
            :bodyStyle="{ 'height': '100vh', 'overflow': 'hidden' }">
            <div v-if="type == 'a'">
                <base-input label="Select Accounts on the List">
                    <br />
                    <a-select v-model="accountIds" mode="multiple" showSearch placeholder="Search Account"
                        optionFilterProp="children" style="width: 100%" :filterOption="filterOption"
                        :notFoundContent="fetching ? undefined : null"> <!-- @search="handleSearch" -->
                        <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                        <a-select-option v-for="option in accountOptions" :key="option.id"
                            :value="option.id">{{ option.account_name }}</a-select-option>
                    </a-select>
                </base-input>
            </div>

            <div v-if="type == 's'" class="mb-3">
                <h6 class="heading-small text-muted pb-3">Select sites where updated version will be deployed</h6>
                <a-spin :spinning="loading">
                    <!-- Search Input for Sites -->
                    <a-input v-model="searchQuery" placeholder="Search Site" style="margin-bottom: 10px; width: 100%" />
                    <ul class="list-group list-group-flush" style="width:100%;">
                        <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7;">
                        <div class="row">
                            <div class="col-md-6">
                                SITE LIST
                            </div>
                            <div class="col-md-6">
                            <!-- @change="onCheckAllChangeAccess" :checked="selectedAccessRights.length == 12" -->
                            <a-checkbox class="float-right" @change="onCheckAllUpdateSiteList"
                                :checked="siteIds.length == sites.length" />
                            </div>
                        </div>
                        </li>
                    </ul>

                    
                    <div class="site-scroll">
                        <ul class="list-group list-group-flush  mb-5" style="width:100%;">
                            <li class="list-group-item" style="font-size: 14px"  v-for="site in filteredSites" :key="site.id">
                                <div class="row">
                                    <div class="col-md-6">
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{ site.name }}
                                    </div>
                                <div class="col-md-6">
                                    <a-checkbox @change="onCheckUpdateSiteList(site.id)"
                                    :checked="siteIds.includes(site.id)" class="float-right">
                                    </a-checkbox>
                                </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </a-spin>

                <div class="float-right my-2" style="position: absolute; bottom: 15px; right: 20px;">
                    <button class="btn btn-primary" @click.prevent="onClose">Cancel</button>
                    <button class="btn btn-success" @click="updateSelectedSite">Save</button>
                </div>
            </div>

            <div v-if="type == 't'">
                <h6 class="heading-small text-muted pb-3">Select terminals where updated version will be deployed</h6>
                <ul class="list-group list-group-flush"
                    style="width: 100%; height: calc(100vh - 160px); overflow: auto">
                    <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7">
                        <div class="row">
                            <div class="col-md-8">
                                TERMINAL LIST
                            </div>
                            <div class="col-md-4">
                                <!-- @change="onCheckAllChangeAccess" :checked="selectedAccessRights.length == 12" -->
                                <a-checkbox class="float-right" @change="onCheckAllUpdateTerminalList()"
                                    :checked="terminalIds.length == terminals.length" />
                            </div>
                        </div>
                    </li>

                    <li class="list-group-item" style="font-size: 14px" v-for="(terminal, index) in terminals"
                        :key=index>
                        <div class="row">
                            <div class="col-md-8">
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{ terminal.name }}
                            </div>
                            <div class="col-md-4">
                                <a-checkbox data-id="system_module.name"
                                    @change="onCheckUpdateTerminalList(terminal.id)"
                                    :checked="terminalIds.includes(terminal.id)" class="float-right" />
                            </div>
                        </div>
                    </li>
                </ul>

                <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
                    <button class="btn btn-primary" @click.prevent="onClose">Cancel</button>
                    <button class="btn btn-success" @click="updateSelectedTerminal()">Save</button>
                </div>
            </div>

        </a-drawer>
        <div class="container-fluid mt--7">
            <div class="card mb-3">
                <div class="row no-gutters" style="min-height: 56vh; overflow: hidden;">
                    <div class="col-md-12" style="max-height: 150vh;">
                        <a-tabs v-model:activeKey="activeKey" @change="createPosUpdate">
                            <a-tab-pane tab="POS Version Dashboard" key="1">
                                <div class="ml-3 mt-3 mr-3">
                                    <pos-release :key="tableKey" @changePosRelease="changePosRelease($event)" />
                                </div>
                            </a-tab-pane>
                            <a-tab-pane tab="POS Release" key="2">
                                <a-spin :spinning="spinning" :tip="spinning_tip">
                                    <div class="ml-3 mt-3 mr-3">
                                        <!-- {{accounts}} -->
                                        <div v-if="posRelease != null">
                                            <a-card title="Upload New POS Version" size="small" style="width: 100%">
                                                <a slot="extra" href="#">
                                                    <button v-if="pos_update_id == 0 || view_mode == false"
                                                        class="float-right btn btn-sm btn-success mr-2"
                                                        @click="updateConfig">
                                                        <span class="fa fa-save" /> Save POS Release </button>
                                                    <button v-if="pos_update_id > 0" class="float-right btn btn-sm mr-2"
                                                        @click="activeKey = '1'; createPosUpdate();"> <span
                                                            class="fa fa-arrow-left" /> Back </button>
                                                </a>

                                                <div class="row align-items-center">
                                                    <div class="col-md-12">
                                                        <base-alert v-if="errors.length" type="danger">
                                                            <b>You have the following error(s):</b>
                                                            <li v-for="error in errors" :key="error">{{ error }}</li>
                                                        </base-alert>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <div class="col-md-12">
                                                            <base-input label="OS:">
                                                                <a-select v-model="inputOs" :disabled="view_mode || this.inputStatus == 'D'"
                                                                    showSearch placeholder="OS"
                                                                    optionFilterProp="children" style="width: 100%"
                                                                    :filterOption="filterOption" >
                                                                    <a-select-option v-for="option in OsOptions"
                                                                        :key="option.key"
                                                                        :value="option.key">{{ option.value }}</a-select-option>
                                                                </a-select>
                                                            </base-input>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <base-input label="Version:">
                                                             <!-- <a-tag color="green" v-if="latestVersion != ''">Latest: {{latestVersion}}</a-tag> -->
                                                                <a-input v-model='inputVersion' :disabled="view_mode || pos_update_id > 0"
                                                                    type='text' label="Version:"
                                                                    input-classes="form-control" />
                                                            </base-input>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <base-input label="Type:">
                                                                <a-select v-model="inputType" :disabled="view_mode || this.inputStatus == 'D'"
                                                                    showSearch placeholder="Type"
                                                                    optionFilterProp="children" style="width: 100%"
                                                                    :filterOption="filterOption">
                                                                    <a-select-option v-for="option in OsTypes"
                                                                        :key="option.key"
                                                                        :value="option.key">{{ option.value }}</a-select-option>
                                                                </a-select>
                                                            </base-input>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <base-input label="Status:">
                                                                <a-select v-model="inputStatus" :disabled="view_mode || this.inputStatus == 'D'"
                                                                    showSearch placeholder="Status"
                                                                    optionFilterProp="children" style="width: 100%"
                                                                    :filterOption="filterOption">
                                                                    <a-select-option v-for="option in OsStatus"
                                                                        :key="option.key"
                                                                        :value="option.key">{{ option.value }}</a-select-option>
                                                                </a-select>
                                                            </base-input>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <base-input alternative="" label="Deployed At:">
                                                                <!-- <a-date-picker v-model="inputDeployedAt" :disabled="view_mode" format="MM-DD-YYYY" :disabled-date="disabledDate" placeholder="Deployed At" style="width:100%"/> -->
                                                                <a-date-picker :show-time="{ format: 'HH:mm' }"
                                                                    format="YYYY-MM-DD HH:mm" style="width: 100%"
                                                                    v-model="inputDeployedAt"
                                                                    placeholder="Select deployment date and time"
                                                                    :disabled="view_mode  || this.inputStatus == 'D'"
                                                                    :disabled-date="disabledDate"
                                                                    @change="onDateChange" />
                                                                <small class="text-muted d-block mt-1">
                                                                    Auto deployment is available only at 8:00 AM, 9:00 AM, and 10:00 AM daily.
                                                                    Other selected times require manual deployment.
                                                                </small>
                                                            </base-input>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <base-input alternative="" label="Applies For:"><br>
                                                                <a-switch :disabled="view_mode" class="float-left"
                                                                    checked-children="For All Accounts"
                                                                    un-checked-children="For Selected Accounts"
                                                                    v-model="accountFilter" />
                                                            </base-input>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <a-spin :spinning="spinning_upload" tip="Uploading to S3...">
                                                            <div class="col-md-12" style="height: 100%">
                                                                <a-upload-dragger :disabled="view_mode  || this.inputStatus == 'D'" accept=".zip"
                                                                    :file-list="posUpdate" @change="handleposUpdate"
                                                                    :remove="handleRemoveposUpdate"
                                                                    :before-upload="beforeUploadposUpdate">
                                                                    <p class="ant-upload-drag-icon"><a-icon
                                                                            type="inbox" /></p>
                                                                    <p class="ant-upload-text">Click or drag file to
                                                                        this area
                                                                        to upload your pos update file</p>
                                                                    <p class="ant-upload-hint">Supports single upload of
                                                                        zip
                                                                        file (.zip)</p>
                                                                </a-upload-dragger>

                                                                <hr class='my-2'>
                                                                <div class="col-12 mt-2 px-0">
                                                                    <a-upload accept=".pdf , .txt"
                                                                        :file-list="releaseNotesPdfFile"
                                                                        @change="handleChangeReleaseNotes"
                                                                        :remove="handleRemoveReleaseNotes"
                                                                        :before-upload="beforeUploadReleaseNotes"
                                                                        :disabled="view_mode">
                                                                        <a-button :disabled="view_mode  || this.inputStatus == 'D'"> <a-icon
                                                                                type="upload" /> Click to Upload Release
                                                                            Notes
                                                                            (.pdf/.txt)</a-button>
                                                                    </a-upload>
                                                                    <br /><br />
                                                                    <a v-if="this.pos_update_id > 0"
                                                                        :href="posSourcePath"><i
                                                                            class="fa fa-archive"></i> POS File</a>
                                                                    <br />
                                                                    <a v-if="this.pos_update_id > 0"
                                                                        :href="posReleaseNotesPath"><i
                                                                            class="fa fa-file-pdf"></i> Release Note</a>
                                                                </div>
                                                            </div>
                                                        </a-spin>
                                                    </div>
                                                </div>
                                            </a-card>
                                        </div>


                                        <br>

                                        <div v-if="accountFilter == false">
                                            <div class="row no-gutters">
                                                <div class="col-md-4"
                                                    style="border-right: 1px solid #e0e0e0; height: 600px;">
                                                    <div class="list-group list-group-flush">
                                                        <div class="list-group-item"
                                                            style="font-size: 14px; height: 55px; background-color: #f7f7f7;">
                                                            <div class="row">
                                                                <div class="col-md-8">Accounts</div>
                                                                <div class="col-md-4 float-right">
                                                                    <base-button :disabled="view_mode"
                                                                        class="float-right ml-1" type="primary"
                                                                        size="sm" @click="openDrawer('a')"><span
                                                                            class="fa fa-plus" /></base-button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-if="accounts.length > 0"
                                                            style="height: 550px; overflow: auto">
                                                            <div class="list-group-item"
                                                                style="font-size: 14px; border-radius: 0px;"
                                                                v-for="(account, index) in accounts" :key="index"
                                                                :class="[{ selected2: selectedAccount == account.id }]">
                                                                <div class="row" @click="setAccount(account)">
                                                                    <div class="col-md-8">{{ account.account_name }}</div>
                                                                    <div class="col-md-4"><span
                                                                            class="ni ni-bold-right float-right"
                                                                            style="padding-bottom: 5px" /></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-else>
                                                            <a-empty class='mt-5' :image-style="{ height: '50px', }">
                                                                <span slot="description"> Please add accounts on the
                                                                    list.
                                                                </span>
                                                            </a-empty>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4"
                                                    style="border-right: 1px solid #e0e0e0; height: 600px">
                                                    <div class="list-group list-group-flush">
                                                        <div class="list-group-item"
                                                            style="font-size: 14px; height: 55px; background-color: #f7f7f7;">
                                                            <div class="row">
                                                                <div class="col-md-8">Site List</div>
                                                                <!-- <div class="col-md-6 float-right"><base-button class="float-right ml-1" type="primary" size="sm" @click="showDrawer('addMenu', selectedMenu, 0)">+ Add Menu</base-button></div> -->
                                                                <div v-if="selectedAccount > 0"
                                                                    class="col-md-4 float-right">
                                                                    <base-button :disabled="view_mode"
                                                                        class="float-right ml-1" type="primary"
                                                                        size="sm" @click="openDrawer('s')"><span
                                                                            class="fa fa-plus" /></base-button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <a-spin :spinning="loading">
                                                            <div v-if="selectedAccount > 0">
                                                                <div v-if="sitesDisplay.length > 0"
                                                                    style="height: 550px; overflow: auto">
                                                                    <div class="list-group-item"
                                                                        style="font-size: 14px; border-radius: 0px;"
                                                                        v-for="(site, index) in sitesDisplay" :key="index"
                                                                        :class="[{ selected2: selectedSite == site.id }]">
                                                                        <!-- @click="setMainMenu(index)" -->
                                                                        <div v-if="selectedAccount > 0" class="row"
                                                                            @click="setSite(site)">
                                                                            <div class="col-md-8">{{ site.name }}</div>
                                                                            <div class="col-md-4"><span
                                                                                    class="ni ni-bold-right float-right"
                                                                                    style="padding-bottom: 5px" /></div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div v-else>
                                                                    <a-empty class='mt-5' :image-style="{ height: '50px', }">
                                                                        <span slot="description"> All sites are selected by
                                                                            default
                                                                            for account
                                                                            <b>{{ activeAccount.account_name }}</b>
                                                                        </span>
                                                                    </a-empty>
                                                                </div>
                                                            </div>
                                                            <div v-else>
                                                                <a-empty class='mt-5' :image-style="{ height: '50px', }">
                                                                    <span slot="description"> Please select an
                                                                        account.</span>
                                                                </a-empty>
                                                            </div>
                                                        </a-spin>
                                                    </div>
                                                </div>
                                                <div class="col-md-4" style="height: 600px">
                                                    <div class="list-group list-group-flush">
                                                        <div class="list-group-item"
                                                            style="font-size: 14px; height: 55px; background-color: #f7f7f7;">
                                                            <div class="row">
                                                                <div class="col-md-8">Terminal List</div>
                                                                <div v-if="selectedSite > 0"
                                                                    class="col-md-4 float-right">
                                                                    <base-button :disabled="view_mode"
                                                                        class="float-right ml-1" type="primary"
                                                                        size="sm" @click="openDrawer('t')"><span
                                                                            class="fa fa-plus" /></base-button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="selectedSite > 0">
                                                        <div v-if="terminalsDisplay.length > 0"
                                                            style="height: 550px; overflow: auto">
                                                            <div class="list-group-item"
                                                                style="font-size: 14px; border-radius: 0px;"
                                                                v-for="(terminal, index) in terminalsDisplay"
                                                                :key="index">
                                                                <!-- @click="setMainMenu(index)" -->
                                                                <div v-if="selectedSite > 0" class="row">
                                                                    <div class="col-md-12">{{ terminal.name }}</div>
                                                                    <!-- <div class="col-md-4"><span class="ni ni-bold-right float-right" style="padding-bottom: 5px"/></div> -->
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-else>
                                                            <a-empty class='mt-5' :image-style="{ height: '50px', }">
                                                                <span slot="description"> All terminals are selected by
                                                                    default
                                                                    for site <b>{{ activeSite.name }}</b> </span>
                                                            </a-empty>
                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        <a-empty class='mt-5' :image-style="{ height: '50px', }">
                                                            <span slot="description"> Please select a site. </span>
                                                        </a-empty>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </a-spin>
                            </a-tab-pane>
                        </a-tabs>
                        <br><br>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>

import HTTPRequest from '../../controllers/httpRequest.js'
import ValidateField from '../../components/validateFormUtils.js';
import PosRelease from '../Admin/PosRelease.vue'
import { mapState, mapActions } from 'vuex'
// import { uploadToS3 } from '../../utilities';
import moment from 'moment';
var component_x;

export default {
    components: {
        PosRelease
    },
    computed: {
        ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        filteredSites() {
            const sites = this.sites || [];
            console.log('sites computed', this.sites)
            const q = (this.searchQuery || '').toLowerCase();

            if (!q) return sites;

            return sites.filter(site =>
                (site.name || '').toLowerCase().includes(q)
            );
        }

    },
    data() {
        this.handleSearch = _.debounce(this.handleSearch, 800)
        this.setAccount = _.debounce(this.setAccount, 800)
        this.setSite = _.debounce(this.setSite, 800)
        return {
            searchQuery: "",
            spinning_tip: '',
            view_mode: false,
            pos_update_id: 0,
            activeKey: '1',
            latest_Windows: "-",
            latest_Linux: "-",
            latest_Mac: "-",
            latest_Windows_Status: "-",
            latest_Linux_Status: "-",
            latest_Mac_Status: "-",
            latest_Windows_At: "-",
            latest_Linux_At: "-",
            latest_Mac_At: "-",
            latestVersion: "",
            errors: [],
            accountFilter: true,
            posRelease: {},
            branchFilter: "AB",
            accountOptions: [],
            fetching: false,
            accountIds: [],
            terminalIds: [],
            accountColumns: [
                {
                    title: 'Account Name',
                    dataIndex: 'account_name',
                    scopedSlots: { customRender: 'name' },
                },
                {
                    title: 'Site List',
                    dataIndex: 'operation',
                    scopedSlots: { customRender: 'operation' },
                }
            ],
            activeAccount: null,
            selectedAccount: 0,
            activeSite: null,
            selectedSite: 0,
            sites: [],
            terminals: [],
            accounts: [],
            siteIds: [],
            sitesDisplay: [],
            // terminalIds: [],
            terminalsDisplay: [],
            drawerVisible: false,
            type: null,
            versionDeployed: false,
            posUpdate: [],
            posWaveletTxtList: [],
            posWaveletJson: null,
            posWaveletPrice: null,
            posWaveletId: null,
            posWaveletTextFiles: [],
            posFile1: null,
            posFile2: null,
            posSourcePath: null,
            posReleaseNotesPath: null,
            spinning: false,
            spinning_upload: false,
            loading: false,
            OsOptions: [
                { key: 'W', value: 'Windows' },
                { key: 'L', value: 'Linux' },
                { key: 'M', value: 'Mac' }
            ],
            OsTypes: [
                { key: 'H', value: 'Hotfix' },
                { key: 'S', value: 'Scheduled' }
            ],
            OsStatus: [
                // {key: 'D', value: 'Deployed'},
                { key: 'F', value: 'For Deployment' },
                { key: 'P', value: 'Pending' }
            ],
            inputOs: '',
            inputVersion: '',
            inputType: '',
            inputStatus: 'P',
            // inputDeployedAt: moment().endOf('day'),
            inputDeployedAt: moment().set({ hour: 7, minute: 0, second: 0 }),
            releaseNotesPdfFile: [],
            allAccounts: [], 
            tableKey: 0,
        }
    },
    watch: {
        accountIds(newIds) {
            newIds.forEach(id => {
                const exists = this.allAccounts.some(a => a.id === id)

                if (!exists) {
                    const opt = this.accountOptions.find(o => o.id === id)
                    if (opt) {
                        this.allAccounts.push({
                            id: opt.id,
                            account_name: opt.account_name,
                            sites: [] 
                        })
                    }
                }
            })
            this.accounts = this.allAccounts.filter(a =>
                newIds.includes(a.id)
            )
        },
        accountFilter: function () {
            if (this.accountFilter == true) {
                this.accounts = []
                this.accountIds = []
                this.siteIds = []
                this.terminalIds = []
                this.selectedSite = 0
                this.selectedAccount = 0
                this.activeAccount = 0
                this.activeSite = 0
            }

        }
    },
    methods: {
        refreshPosReleaseTable() {
            this.tableKey += 1; // reload pos release compoenent
        },
        onDateChange(date) {
            if (date) {
                this.inputDeployedAt = moment(date).set({second: 0, millisecond: 0})
            }
        },
        createPosUpdate() {
            this.view_mode = false
            this.inputOs = ''
            this.inputVersion = ''
            this.inputType = ''
            this.inputStatus = ''
            this.inputDeployedAt = ''
            this.posSourcePath = ''
            this.posReleaseNotesPath = ''
            this.pos_update_id = 0
            // this.posRelease.status = ''
            this.posRelease = {}
            this.posSourcePath = null
            this.posReleaseNotesPath = null
            this.accounts = []
            this.accountFilter = true
        },
        async changePosRelease(e) {
            this.spinning = true
            this.spinning_tip = "Fetching POS Update Data..."
            var i = e.split('|')
            this.activeKey = '2';
            this.view_mode = (i[1] == 'V') ? true : false
            this.pos_update_id = i[0]
            this.errors = [];
            //Get Pos Update Details
            var posRelease = await HTTPRequest.getRequest(this.endPoint + 'pos_releases/get_pos_version?id=' + i[0], null,)
            this.posRelease = posRelease.success
            if(this.posRelease.release_config != null){
                const raw = typeof this.posRelease.release_config === 'string' ? JSON.parse(this.posRelease.release_config) : this.posRelease.release_config
                this.allAccounts = raw
                this.accounts = raw.slice()
                this.accountOptions = raw.map(a => ({
                    id: a.id,
                    account_name: a.account_name
                }))
                this.accountIds = raw.map(a => a.id)
                this.accountFilter = false
            } else {
                this.accounts = []
                this.accountFilter = true
            }

            this.inputOs = this.posRelease.os
            this.inputVersion = this.posRelease.version
            this.inputType = this.posRelease.update_type
            this.inputStatus = this.posRelease.status
            this.inputDeployedAt = this.posRelease.deployed_at
            this.posSourcePath = this.posRelease.path
            this.posReleaseNotesPath = this.posRelease.release_notes

            if (this.posRelease.status == 'D')
                this.versionDeployed = true
            else
                this.versionDeployed = false
            this.spinning = false
        },
        handleRemoveReleaseNotes(file) {
            const index = this.releaseNotesPdfFile.indexOf(file);
            const newFileList = this.releaseNotesPdfFile.slice();
            newFileList.splice(index, 1);
            this.releaseNotesPdfFile = newFileList;
        },
        beforeUploadReleaseNotes(file) {
            this.releaseNotesPdfFile = [...this.releaseNotesPdfFile, file];
            return false;
        },
        async handleChangeReleaseNotes(file) {
            this.spinning_upload = true
            var latestUpload = this.releaseNotesPdfFile[this.releaseNotesPdfFile.length - 1]
            if (latestUpload != undefined) {
                var fileExtension = latestUpload.name.split(".").pop()
                // alert(fileExtension)
                if ((fileExtension != "pdf") && (fileExtension != "txt")) {
                    this.$notification['error']({
                        message: 'Unsupported file type',
                        description: "Upload .pdf files only."
                    });
                    this.handleRemoveReleaseNotes(file)
                    this.spinning_upload = false
                } else {
                    if (this.releaseNotesPdfFile.length > 1)
                        this.handleRemoveReleaseNotes(this.releaseNotesPdfFile[0])
                }
            }

            // const newFileName = latestUpload.name
            // const myRenamedFile = new File([file], newFileName);
            // this.posReleaseNotesPath = await uploadToS3(myRenamedFile, 'pos_release_notes');

            const formData = new FormData();
            formData.append('file', file.file);
            this.posReleaseNotesPath = await HTTPRequest.postRequest(this.endPoint + 'upload_to_s3', null, formData, 'BXI-File');

            if (this.posReleaseNotesPath['error']) {
                this.$notification['error']({
                    message: 'S3 uploader error',
                    // description: this.posReleaseNotesPath['error'].code + " : " + this.posReleaseNotesPath['error'].message
                    description: this.posReleaseNotesPath['error']
                });
                this.handleRemoveReleaseNotes(file)
                this.spinning_upload = false
            } else {
                this.spinning_upload = false
                return this.posReleaseNotesPath = this.posReleaseNotesPath['path']
            }
            this.spinning_upload = false
        },
        async handleposUpdate(file) {
            this.spinning_upload = true
            var latestUpload = this.posUpdate[this.posUpdate.length - 1]
            if (latestUpload != undefined) {
                var fileExtension = latestUpload.name.split(".").pop()
                if (fileExtension != "zip") {
                    this.$notification['error']({
                        message: 'Unsupported file type',
                        description: "Upload .zip files only."
                    });
                    this.handleRemoveposUpdate(file)
                    this.spinning_upload = false
                } else {
                    if (this.posUpdate.length > 1)
                        this.handleRemoveposUpdate(this.posUpdate[0])
                }
            }
            // const newFileName = latestUpload.name
            // const myRenamedFile = new File([file], newFileName);
            // this.posSourcePath = await uploadToS3(myRenamedFile, 'pos_updates');

            const formData = new FormData();
            formData.append('file', file.file);
            this.posSourcePath = await HTTPRequest.postRequest(this.endPoint + 'upload_to_s3', null, formData, 'BXI-File');

            if (this.posSourcePath['error']) {
                this.$notification['error']({
                    message: 'S3 uploader error',
                    // description: this.posSourcePath['error'].code + " : " + this.posSourcePath['error'].message
                    description: this.posSourcePath['error']
                });
                this.handleRemoveposUpdate(file)
                this.spinning_upload = false
            } else {
                this.spinning_upload = false
                return this.posSourcePath = this.posSourcePath['path']
            }
            this.spinning_upload = false
        },
        disabledDate(current) {
             return current && current < moment().startOf('day')
        },
        handleRemoveposUpdate(file) {
            const index = this.posUpdate.indexOf(file);
            const newFileList = this.posUpdate.slice();
            newFileList.splice(index, 1);
            this.posUpdate = newFileList;
        },
        beforeUploadposUpdate(file) {
            this.posUpdate = [...this.posUpdate, file];
            return false;
        },
        updateSelectedSite() {
            this.sitesDisplay = []
            this.activeAccount.sites = []
            this.sites.map(x => {
                if (this.siteIds.includes(x.id)) {
                    this.sitesDisplay.push(x)
                    this.activeAccount.sites.push({ id: x.id, name: x.name, terminals: [] })
                }
            })
            this.onClose()
        },
        onCheckUpdateSiteList(siteId) {
            if (this.siteIds.includes(siteId)) {
                var index = this.siteIds.indexOf(siteId);
                this.siteIds.splice(index, 1)
            }
            else {
                this.siteIds.push(siteId)
            }
        },
        onCheckAllUpdateSiteList() {
            if (this.siteIds.length == this.sites.length) {
                this.siteIds = []
            } else {
                this.siteIds = []
                this.sites.map(x => {
                    this.siteIds.push(x.id)
                })
            }
        },
        updateSelectedTerminal() {
            this.terminalsDisplay = []
            this.activeSite.terminals = []
            this.terminals.map(x => {
                if (this.terminalIds.includes(x.id)) {
                    this.terminalsDisplay.push(x)
                    this.activeSite.terminals.push({ id: x.id, name: x.name })
                }
            })
            this.activeAccount.sites.map(y => {
                if (y.id == this.selectedSite) {
                    y.terminals = this.activeSite.terminals
                }
            })
            this.onClose()
        },
        onCheckUpdateTerminalList(terminalId) {
            if (this.terminalIds.includes(terminalId)) {
                var index = this.terminalIds.indexOf(terminalId);
                this.terminalIds.splice(index, 1)
            }
            else {
                this.terminalIds.push(terminalId)
            }
        },
        onCheckAllUpdateTerminalList() {
            if (this.terminalIds.length == this.terminals.length) {
                this.terminalIds = []
            } else {
                this.terminalIds = []
                this.terminals.map(x => {
                    this.terminalIds.push(x.id)
                })
            }
        },
        onClose() {
            this.drawerVisible = false
        },
        async openDrawer(type) {
            this.type = type
            this.drawerVisible = true
            if (type == 'a') {
                await this.handleSearch('')
            }
        },
        async setAccount(account) {
            this.activeAccount = account
            this.selectedAccount = account.id;
            this.sitesDisplay = []
            this.terminalsDisplay = []
            this.loading = true
            var sites = await HTTPRequest.getRequest(this.endPoint + "/sites/get_valid_sites?mode=pos_update_admin&account_id=" + account.id, null, 'BXI-File')
            this.sites = sites
            this.sites.sort((a, b) => { return a.name.toLowerCase().localeCompare(b.name.toLowerCase()) })
            if (this.activeAccount.sites != undefined || this.activeAccount.sites != null) {
                this.activeAccount.sites.map(x => {
                    this.siteIds.push(x.id) && this.sitesDisplay.push(x)
                })
            }
            this.loading = false
        },
        async setSite(site) {
            this.activeSite = site;
            this.selectedSite = site.id;
            this.terminalsDisplay = []
            var terminals = await HTTPRequest.getRequest(this.endPoint + "/terminals?mode=admin&site_id=" + site.id + "&account_id=" + this.selectedAccount, null, null)
            this.terminals = terminals.data
            this.terminals.sort((a, b) => { return a.name.toLowerCase().localeCompare(b.name.toLowerCase()) })
            if (this.activeSite.terminals != undefined || this.activeSite.terminals != null) {
                this.activeSite.terminals.map(x => {
                    this.terminalIds.push(x.id) && this.terminalsDisplay.push(x)
                })

            }
        },
        filterOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        },
        checkVersion() {
            this.errors = []
            if (this.latestVersion != '' || this.latestVersion != null) {
                if (this.latestVersion.split(' | ')[0].replace(".", "") >= this.inputVersion.replace(".", "")) {
                    this.inputVersion = ""
                    this.errors.push('The version must be higher than the current version.');
                    this.errors = this._.compact(this.errors);
                    return this.errors.length;
                }
            }
        },
        async getLatestVersion(account_ids) {
            this.errors = [];
            if (this.pos_update_id == 0) {
                var version = await HTTPRequest.getRequest(this.endPoint + "/pos_releases/get_latest_version?os=" + this.inputOs + "&account_ids=" + account_ids, null, null);
                if (version != null) {
                    const currentStr = version.version;
                    const inputStr   = this.inputVersion;

                    this.latestVersion = currentStr + ' | ' + version.status;

                    // version validation
                    if (this.compareVersions(inputStr, currentStr) <= 0) {
                        this.errors.push('The version must be higher than the current version.');
                    }
                    // duplicate
                    if (version.path_exists) {
                        this.errors.push('This file path has already been uploaded.');
                    }
                } else {
                    this.latestVersion = '';
                }
            }
            this.errors = this._.compact(this.errors);
            return this.errors.length;
        },
        compareVersions(v1, v2) {
            const a = v1.split('.').map(Number);
            const b = v2.split('.').map(Number);
            const len = Math.max(a.length, b.length);
            for (let i = 0; i < len; i++) {
                const x = a[i] || 0;
                const y = b[i] || 0;

                if (x > y) return 1;
                if (x < y) return -1;
            }
            return 0;
        },
        async handleSearch(value) {
            this.fetching = true;
            var accounts = await HTTPRequest.getRequest(this.endPoint + "/accounts/get_valid_accounts?name=" + value, null, null)
            accounts.sort((a, b) => { return a.account_name.toLowerCase().localeCompare(b.account_name.toLowerCase()) })
             const map = new Map()
            this.accountOptions.forEach(o => map.set(o.id, o))
            accounts.forEach(o => map.set(o.id, o))

            this.accountOptions = Array.from(map.values())
            this.fetching = false
        },
        async getLatest() {
            var posRelease = await HTTPRequest.getRequest(this.endPoint + 'pos_releases/get_latest', null,)
            if (posRelease.warning) {
                this.$notification['warning']({
                    message: 'Version Conflict',
                    description: "Current version is not yet marked as deployed. "
                });
                return;
            }
            if (posRelease.info) {
                this.$notification['info']({
                    message: 'Version Okay',
                    description: "Current version is up to date."
                });
                return;
            }
            if (posRelease.success) {
                this.$notification['success']({
                    message: 'Version Updated',
                    description: "Please configure the new version for release."
                });
                this.posRelease = posRelease.success;
                if (this.posRelease.release_config == null)
                    this.accounts = []
                else
                    this.accounts = JSON.parse(this.posRelease.release_config)
                this.accountFilter = true
                this.versionDeployed = false
                // this.posRelease = posRelease.success;
                return;
            }
        },
        async updateConfig() {
            const accountIds = this.accounts.map(acc => acc.id).join(",");

            if (!this.validateForm()) {
                if (await this.getLatestVersion(accountIds) === 0) {
                    this.spinning = true;
                    this.spinning_tip = "Saving POS Release..."
                    var release_configs = []
                    release_configs.push({
                        account_id: null,
                        site_id: null,
                        terminal_id: null
                    })
                    var releaseConfig = (this.accountFilter == true) ? null : JSON.stringify(this.accounts)
                    // var releaseConfig = (this.accountFilter == true) ? null : this.accounts
                    var release_details = []
                    release_details.push({
                        path: this.posSourcePath,
                        release_notes: this.posReleaseNotesPath,
                        os: this.inputOs,
                        version: this.inputVersion,
                        update_type: this.inputType,
                        status: this.inputStatus,
                        deployed_at: this.inputDeployedAt,
                    })
                    var posReleasePayload = { release_details: release_details, release_config: releaseConfig, for_all: release_configs }
                    if (this.posRelease.id == undefined)
                        var posRelease = await HTTPRequest.postRequest(this.endPoint + 'pos_releases/new_pos_version?id=' + ((this.posRelease.id == undefined) ? 0 : this.posRelease.id), null, posReleasePayload)
                    else
                        var posRelease = await HTTPRequest.postRequest(this.endPoint + 'pos_releases/update_pos_update?id=' + ((this.posRelease.id == undefined) ? 0 : this.posRelease.id), null, posReleasePayload)
                    // console.log(posRelease)
                    if (posRelease.error == undefined) {
                        this.$notification['success']({
                            message: 'Configuration Saved',
                            description: "Your release has been configured accordingly. "
                        });
                        this.posRelease = [];
                        this.clearFields();
                        this.refreshPosReleaseTable();
                    } else {
                        this.$notification['error']({
                            message: 'Configuration Error',
                            description: posRelease.error
                        });
                    }
                    this.spinning = false;
                }
            }
        },
        validateForm() {
            this.errors = [];
            if (!this.accountFilter)
                this.errors.push(ValidateField.isEmpty("Account", this.accounts));
            this.errors.push(ValidateField.isNull("POS File", this.posSourcePath));
            this.errors.push(ValidateField.isNull("POS Release Notes", this.posReleaseNotesPath));
            this.errors.push(ValidateField.required("OS", this.inputOs));
            this.errors.push(ValidateField.required("Version", this.inputVersion));
            this.errors.push(ValidateField.required("Type", this.inputType));
            this.errors.push(ValidateField.required("Status", this.inputStatus));
            this.errors.push(ValidateField.required("Deployed At", this.inputDeployedAt));
            this.errors = this._.compact(this.errors);
            return this.errors.length;
        },

        clearFields() {
            this.releaseNotesPdfFile = []
            this.posUpdate = []
            this.inputOs = ''
            this.inputVersion = ''
            this.inputType = ''
            this.inputStatus = ''
            // this.inputDeployedAt = moment().endOf('day')
            this.inputDeployedAt = moment().set({ hour: 7, minute: 0, second: 0 })
            this.searchQuery = '';
            this.accounts = [];
            this.siteIds = [];
            this.accountIds = [];
            this.terminalIds = [];
        },
        async getLatestOS(os) {
            var version = await HTTPRequest.getRequest(this.endPoint + "/pos_releases/get_latest_version?os=" + os, null, null)
            if (version != null) {
                let status = (version['status'] == 'D') ? 'Deployed' : this.OsStatus.find(o => o.key === version['status'])['value']
                if (os == 'W') {
                    this.latest_Windows = version['version']
                    this.latest_Windows_Status = status
                    this.latest_Windows_At = moment(version['deployed_at']).format('MMMM DD, YYYY')
                } else if (os == 'L') {
                    this.latest_Linux = version['version']
                    this.latest_Linux_Status = status
                    this.latest_Linux_At = moment(version['deployed_at']).format('MMMM DD, YYYY')
                } else if (os == 'M') {
                    this.latest_Mac = version['version']
                    this.latest_Mac_Status = status
                    this.latest_Mac_At = moment(version['deployed_at']).format('MMMM DD, YYYY')
                }
            }
        },
        async deploy() {
            var posReleasePayload = { pos_release: { status: 'D' } }
            var posRelease = await HTTPRequest.putRequest(this.endPoint + 'pos_releases/' + this.posRelease.id, null, posReleasePayload)
            // console.log(posRelease)
            if (posRelease.error == undefined) {
                this.$notification['success']({
                    message: 'Release Marked as Deployed',
                    description: "Your version is ready for download for all accounts."
                });
            }
            this.getPosRelease()
        },
        async getPosRelease() {
            var posRelease = await HTTPRequest.getRequest(this.endPoint + 'pos_releases/', null,)
            this.posRelease = posRelease.success
            if(this.posRelease.release_config != null){
                this.accounts = JSON.parse(this.posRelease.release_config)
                // this.accounts = this.posRelease.release_config
                //this.accountFilter = false
            }
            if (this.posRelease.status == 'D')
                this.versionDeployed = true
        }
    },
    mounted: async function () {
        component_x = this;
        //await this.getPosRelease()
        if (this.accounts && this.accounts.length > 0) {
            this.accountOptions = this.accounts.map(a => ({
                id: a.id,
                account_name: a.account_name
            }))
            this.accountIds = this.accounts.map(a => a.id)
        }
        await this.getLatestOS('W');
        await this.getLatestOS('L');
        await this.getLatestOS('M');
    }
}
</script>

<style scoped>
.selected2 {
    background-color: #EFF6FF;
    color: #2371CC;
}
.site-scroll {
  max-height: 80vh;    /* fill 70% of screen height */
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
